"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _react2 = require("@xstate/react");
var _xstate = require("xstate");
var _Footer = _interopRequireDefault(require("./Footer"));
var _styles = require("./styles");
var _constants = require("../../lib/constants");
var _propTypes = require("prop-types");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  REVERT,
  SUBMIT
} = _constants.events;
const {
  doneLeft,
  doneRight
} = _constants.states;
const variants = {
  initial: {
    opacity: 0,
    scale: 0.3
  },
  enter: {
    opacity: 1,
    scale: 1
  }
};
const getTrackingFromContext = ctx => {
  var _context, _context2, _context3, _context4;
  // get the last question answered
  const lastAnsweredStep = (0, _find.default)(_context = (0, _reverse.default)(_context2 = [...ctx.chat]).call(_context2)).call(_context, c => !!c.answer);
  return {
    // format last_step_answer as CSV
    last_step_id: lastAnsweredStep ? lastAnsweredStep.id : null,
    last_step_answer: lastAnsweredStep ? lastAnsweredStep.answer.join(', ') : null,
    last_step_question: lastAnsweredStep ? lastAnsweredStep.question : null,
    steps_answered: (0, _filter.default)(_context3 = ctx.chat).call(_context3, c => !!c.answer).length,
    total_answerable_steps: (0, _filter.default)(_context4 = (0, _keys.default)(ctx.stepConfigById)).call(_context4, stepId => ctx.stepConfigById[stepId].options && ctx.stepConfigById[stepId].options.length > 0).length,
    total_steps: (0, _keys.default)(ctx.stepConfigById).length
  };
};
const getCurrentStateMeta = state => ({
  ctx: state.context,
  curState: state.value,
  trackingData: getTrackingFromContext(state.context)
});
const isDoneStep = id => {
  var _context5;
  return (0, _includes.default)(_context5 = [doneLeft, doneRight]).call(_context5, id);
};
function areAnswersEqual(previousAnswer, newAnswer) {
  if (previousAnswer === newAnswer) {
    return true;
  }
  if ((0, _isArray.default)(previousAnswer) && (0, _isArray.default)(newAnswer)) {
    if (previousAnswer.length !== newAnswer.length) {
      return false;
    }
    for (let i = 0; i < previousAnswer.length; i++) {
      if (previousAnswer[i] !== newAnswer[i]) {
        return false;
      }
    }
    return true;
  }
  return false;
}
const GxUi = _ref => {
  let {
    animateInitial,
    name,
    machine,
    onDone,
    onChange,
    renderLeft,
    renderRight
  } = _ref;
  const [state, send] = (0, _react2.useMachine)(machine);
  const {
    context
  } = state;
  const {
    chat
  } = context;
  const stateValue = state.value;

  // handle `done` and `change` callbacks when the machine's state changes
  (0, _react.useEffect)(() => {
    const meta = {
      ...getCurrentStateMeta(state),
      name
    };

    // bail we if end up here on initializtion `before` the user has answered a question
    if (!meta.trackingData.last_step_question) {
      return;
    }
    if (isDoneStep(stateValue)) {
      onDone(meta);
    } else {
      onChange(meta);
    }
  }, [name, state, stateValue, onDone, onChange]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, {
    initial: animateInitial
  }, (0, _map.default)(chat).call(chat, _ref2 => {
    let {
      id,
      question,
      answer,
      uiControl,
      options
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
      key: id,
      variants: variants,
      initial: "initial",
      animate: "enter",
      exit: "exit"
    }, !isDoneStep(id) && /*#__PURE__*/_react.default.createElement(_styles.ChatLine, {
      "data-testid": `gx-question-${id}`
    }, /*#__PURE__*/_react.default.createElement(_styles.Question, {
      id: `gx-question-${id}-question`
    }, question), /*#__PURE__*/_react.default.createElement(_Footer.default, {
      id: id,
      uiControl: uiControl,
      answer: answer,
      options: options,
      ariaDescribedby: `gx-question-${id}-question`,
      onAnswer: newAnswer => {
        if (state.matches(id)) {
          // if the question answered is the
          // state we're on, do a regular submit
          send({
            type: SUBMIT,
            value: newAnswer,
            id
          });
        } else {
          // if the user is re-answering a previously
          // answered question with a different response,
          // first revert to that question before setting
          // a response
          if (!areAnswersEqual(answer, newAnswer)) {
            send({
              type: REVERT,
              id
            });
            send({
              type: SUBMIT,
              value: newAnswer,
              id
            });
          }
        }
      }
    })), id === doneLeft && renderLeft(context), id === doneRight && renderRight(context));
  })));
};
GxUi.propTypes = {
  name: _propTypes.string.isRequired,
  machine: (0, _propTypes.instanceOf)(_xstate.StateNode).isRequired,
  animateInitial: _propTypes.bool,
  onChange: _propTypes.func,
  onDone: _propTypes.func,
  renderLeft: _propTypes.func,
  renderRight: _propTypes.func
};
GxUi.defaultProps = {
  renderLeft: () => '',
  renderRight: () => '',
  animateInitial: false
};
var _default = exports.default = GxUi;
GxUi.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GxUi",
  "props": {
    "renderLeft": {
      "defaultValue": {
        "value": "() => ''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "renderRight": {
      "defaultValue": {
        "value": "() => ''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "animateInitial": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "machine": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "StateNode"
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onDone": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};